module.exports = __webpack_public_path__ + "/images/cover-cta-caja-verde-m.fdd073f.jpg";